export default __webpack_public_path__ + "static/media/icon-done.3e0bc720.svg";